import { render, staticRenderFns } from "./EditPurchasesDeliveryComponent.vue?vue&type=template&id=2e70f045"
import script from "./EditPurchasesDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./EditPurchasesDeliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports